import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    pushUpsList(data) {
        return axios.request({
            url: "mwap/calorieinfo",
            method: "post",
            data
        });
    },
    tabsubmenu(data) {
        return axios.request({
            url: "mwap/tabsubmenu",
            method: "post",
            data
        });
    },
    pushUpsDetail(data) {
        return axios.request({
            url: "mwap/caloriegame",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                res.data.imgurl = `${res.data.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_574,h_355,ar_auto`
            }
            return res;
        });
    },
    calorie(data) {
        return axios.request({
            url: "mwap/submitcalorie",
            method: "post",
            data
        });
    },
    showList(data) {
        return axios.request({
            url: "mwap/compareinfo",
            method: "post",
            data
        });
    },
    showSubList(data) {
        return axios.request({
            url: "mwap/comparesubinfo",
            method: "post",
            data
        });
    },
    ropesublist(data) {
        return axios.request({
            url: "mwap/ropesublist",
            method: "post",
            data
        }).then((res) =>{
            if(res.status * 1 === 200){
                var now = Date.parse(new Date())/1000;
                res.data.list.forEach((item, index) => {
                  if (now < item.start_time) {
                    item.type = 1;
                    item.state = "未开始";
                    item.fontcolor = "#FFFFFF";
                    item.bgcolor= "rgba(128, 134, 149,.9)";
                  } else if (now >= item.start_time && now <= item.end_time) {
                    item.type = 2;
                    item.state= "去参赛";
                    item.fontcolor= "#FFFFFF";
                    item.bgcolor= "#1D9A71";
                  } else if (now > item.end_time) {
                    item.type = 3;
                    item.state= "已结束";
                    item.fontcolor= "#FFFFFF";
                    item.bgcolor= "rgba(128, 134, 149,.9)";
                  }
                });
            }
            return res;
        });
    },
    showDetail(data) {
        return axios.request({
            url: "mwap/comparegame",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                res.data.imgurl = `${res.data.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_750,h_431,ar_auto`
            }
            return res;
        });
    },
    showSubDetail(data) {
        return axios.request({
            url: "mwap/comparesubgame",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                res.data.imgurl = `${res.data.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_750,h_431,ar_auto`
            }
            return res;
        });
    },
    ropesubdetail(data) {
        return axios.request({
            url: "mwap/ropesubdetail",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                res.data.imgurl = `${res.data.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_750,h_431,ar_auto`
            }
            return res;
        });
    },
    submitsubrope(data) {
        return axios.request({
            url: "mwap/submitsubrope",
            method: "post",
            data
        });
    },
    ropesubrank(data) {
        return axios.request({
            url: "mwap/ropesubrank",
            method: "post",
            data
        });
    },
    ropesubrank1(data) {
        return axios.request({
            url: "mwap/ropesubrank1",
            method: "post",
            data
        });
    },
    comparesub(data) {
        return axios.request({
            url: "mwap/submitsubcompare",
            method: "post",
            data
        });
    },
    compare(data) {
        return axios.request({
            url: "mwap/submitcompare",
            method: "post",
            data
        });
    },
    compareRank(data) {
        return axios.request({
            url: "mwap/comparerank",
            method: "post",
            data
        });
    },
    compareSubRank(data) {
        return axios.request({
            url: "mwap/comparesubrank",
            method: "post",
            data
        });
    },
    ropegame(data) {
        return axios.request({
            url: "mwap/ropegame",
            method: "post",
            data
        });
    },
    ropesubgame(data) {
        return axios.request({
            url: "mwap/ropesubgame",
            method: "post",
            data
        });
    },
    roperank(data) {
        return axios.request({
            url: "mwap/roperank",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                res.data.imgurl = `${res.data.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_750,h_431,ar_auto`
            }
            return res;
        });
    },
    submitrope(data) {
        return axios.request({
            url: "mwap/submitrope",
            method: "post",
            data
        });
    },
    myVideos(data) {
        return axios.request({
            url: "mwap/my-videos",
            method: "post",
            data
        });
    }
}